import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  CheckRevokeRoleAffectedUsersArgs,
  FetchRoleByIdArgs,
  FetchRolesArgs,
} from '../api/types/roles.types';

import {
  checkRevokeRoleAffectedUsers,
  fetchRoleById,
  fetchRoles,
} from '../api/roles.api';

export const rolesQueryKeys = createQueryKeys('roles', {
  checkRevokeRoleAffectedUsers: ({
    id,
    organizationId,
  }: CheckRevokeRoleAffectedUsersArgs) => ({
    queryFn: () => checkRevokeRoleAffectedUsers({ id, organizationId }),
    queryKey: [organizationId, id],
  }),
  fetchInfiniteRoles: ({ filters, organizationId }: FetchRolesArgs) => ({
    queryFn: (context) =>
      fetchRoles({
        filters: {
          ...filters,
          offset: (context?.pageParam as string) || '1',
          orderBy: filters?.orderBy || 'name',
        },
        organizationId,
      }),
    queryKey: [organizationId, filters],
  }),
  fetchRoleById: ({ id, organizationId }: FetchRoleByIdArgs) => ({
    queryFn: () => fetchRoleById({ id }),
    queryKey: [organizationId, id],
  }),
  fetchRoles: ({ filters, organizationId }: FetchRolesArgs) => ({
    queryFn: () => fetchRoles({ filters, organizationId }),
    queryKey: [organizationId, filters],
  }),
});
